// Closely coupled scripts for all page.fruit templates
// uses jQuery


$(() => {
    // Play video when scrolled to
    $(window).on('scroll', function() {
        const scrollPos = $(window).scrollTop() + ($('video').height() / 2);
        const videoPos = $('video').offset().top;
        const difference = Math.abs(scrollPos - videoPos);
        if (difference < 20) { 
              $('video')[0].play();
          } 
    })


    // function hideOnClickOutside(selector) {
    //     function removeClickListener() {
    //         document.removeEventListener('click', outsideClickListener)
    //     }
    //     function outsideClickListener(event) {
    //       const $target = $(event.target);
    //       if (!$target.closest(selector).length && $(selector).is(':visible')) {
    //           $(selector).find('em').hide();
    //           removeClickListener();
    //       }
    //     }
    //     document.addEventListener('click', outsideClickListener)
    //   }

    // Add Popover's
    // find all instances of an <a> tag in the <li>
    // add click handler for mobile
    // add hover hanlder for desktop
    // function handleLinkClick(link) {
    //     link.on('click', function(event){
    //         $(this).find('em').show();
    //         hideOnClickOutside($(this));
    //     });
    // }

    // function handleLinkHover(link) {
    //     link.hover(function(){
    //         $(this).find('em').show();
    //     }, function(){
    //         $(this).find('em').hide();
    //     });
    // }

    // $('[data-benefit-item]').each(function() {
    //     const link = $(this).find('a');
    //     link.each(function() {
    //         handleLinkClick($(this));
    //         handleLinkHover($(this));
    //     })
    // })

    // Fruit History Slider
    let currentSlide = $('[data-fruit-history]').data('current-slide');
    const totalSlides = $('[data-fruit-history]').data('total-slides');

    function updateHistorySlide(slide) {
        // Update Image
        const historyImgs = $('[data-history-img]');
        historyImgs.each(function() { 
            if ($(this).data('index') == slide ) {
                $(this).show();
            } else {
                $(this).hide();
            }
         });

         // Update Text
        const historyTexts = $('[data-history-text]');
        historyTexts.each(function() { 
            if ($(this).data('index') == slide ) {
                $(this).show();
            } else {
                $(this).hide();
            }
         });
    }

    function updateHistoryButtons(slide) {
        if (slide == 1 ) {
            $('[data-fruit-history-back]').hide();
        } else {
            $('[data-fruit-history-back]').show();
        }
        if (slide == totalSlides) {
            $('[data-fruit-history-next]').hide();
        } else {
            $('[data-fruit-history-next]').show();
        }
    }

    function updateHistoryBreadcrumbs(slide) {
        $('[data-history-circle]').each(function() {
            if ($(this).data('index') <= slide) {
                $(this).find('circle').css('fill', 'white');
            } else {
                $(this).find('circle').css('fill', '#CC6AA2');
            }
        }) 
        $('[data-history-line]').each(function() {
            if ($(this).data('index') <= slide) {
                $(this).find('line').css('stroke', 'white');
            } else {
                $(this).find('line').css('stroke', '#CC6AA2');
            }
        }) 
    }

    function handleHistoryUpdate(slide) {
        updateHistorySlide(slide);
        updateHistoryButtons(slide);
        updateHistoryBreadcrumbs(slide);
    }

    $('[data-fruit-history-back]').on('click', function() {
        currentSlide--;
        handleHistoryUpdate(currentSlide);
    });

    $('[data-fruit-history-next]').on('click', function(){
        currentSlide++;
        handleHistoryUpdate(currentSlide);
    })

    $('[data-history-circle]').on('click', function(){
        currentSlide = $(this).data('index');
        handleHistoryUpdate(currentSlide);
    });

    handleHistoryUpdate(currentSlide);
})